module.exports = __webpack_public_path__ + "img/apple-touch-icon.091b0484.png";